module.exports = __webpack_public_path__ + "static/media/12-spotted-dragonfly-1.5e4f9635.jpg";